import { Button, Empty, notification, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { FaComment, FaCommentSlash } from "react-icons/fa";
import { MdDescription } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import CommentsComponent from "../../components/comments/comments.component";
import SmallSpinnerComponent from "../../components/spinner/small-spinner.component";
import VideoPlayer from "../../components/video/video-player";
import {
  clearCheckFilesName,
  saveCheckFilesName,
  toggleCheckFilesCheckbox,
} from "../../redux/actions/check-files.action";
// import { extractNumberFromString } from "../../services/config";
// import {
//   getDraftFileByBookName,
// } from "../../services/indexed-db/draftfiles.indexeddb";
import {getDraftedFilesByBookNameOnline} from "../../services/api-calls/draft-files.api"

const CrossCheckVideo = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [resultantNumber, setResultantNumber] = useState("");
  const [commentData, setCommentData] = useState({});
  const [commnetObjId, setCommnetObjId] = useState("");

  const isPlayingStatus = useSelector((state) => state.playingStatusReducer);
  const isRecordingStatus = useSelector(
    (state) => state.recordingStatusReducer
  );

  useEffect(() => {
    loadFiles();

    return () => {
      dispatch(clearCheckFilesName());
      dispatch(toggleCheckFilesCheckbox(false));
      localStorage.removeItem("checkPageMsg");
    };
  }, [location]);

  const loadFiles = () => {
    return new Promise(async (resolve, reject) => {
      try {
        setIsLoading(true);
        // let resultantNumberData = await extractNumberFromString(
        //   `${location.state?.verse}`
        // );
        // setResultantNumber(resultantNumberData);
        let name = `${location.state?.verse}`;
        // let allFiles = await getDraftFileByBookName(
        //   location.state.book.bookName
        // );

        let draftData = {
          projectId:location.state?.book.projectId,
          bookName: location.state.book.bookName,
        };
       
        let allFiles = await getDraftedFilesByBookNameOnline(draftData);
        // let allFiles = await [...draftData.data];


        if (localStorage.getItem("role") == "Facilitator") {
          let crossCheckFiles = allFiles.filter(
            (item) =>
              item.isSelected == true &&
              item.sourceVerseName==name &&
              // item.formattedName == name &&
              item.targetType == "draft" &&
              item.userId !== localStorage.getItem("id") &&
              item.fileType == "video" &&
              item.translatorStatusCheck == true
          );
          setList(crossCheckFiles);

          if (
            crossCheckFiles[0].communityStatusCheck == true &&
            localStorage.getItem("role") == "Facilitator"
          ) {
            dispatch(toggleCheckFilesCheckbox(true));
          } else {
            toggleCheckFilesCheckbox(false)
            dispatch(saveCheckFilesName(crossCheckFiles[0].fileId));
          }
          setIsLoading(false);
        } else {
          let selectedFiles = allFiles.filter(
            (item) =>
              item.isSelected == true &&
              item.sourceVerseName==name &&
              // item.formattedName == name &&
              item.targetType == "draft" &&
              item.userId !== localStorage.getItem("id") &&
              item.fileType == "video"
          );

          setList(selectedFiles);
          setIsLoading(false);
          if (selectedFiles.length > 0) {
            if (
              selectedFiles[0].translatorStatusCheck == true &&
              localStorage.getItem("role") == "MTT"
            ) {
              dispatch(toggleCheckFilesCheckbox(true));
            } else {
              toggleCheckFilesCheckbox(false)
              dispatch(saveCheckFilesName(selectedFiles[0].fileId));
            }
          }
        }
      } catch (error) {
        setIsLoading(false);
      }
    });
  };

  const toggleComments = (data, id) => {
    // setShowComments(!showComments);
    // setCommentData(data);
    // setCommnetObjId(id);

    if (showComments == true && commnetObjId == id) {
      setShowComments(false);
    } else if (showComments == true) {
      setCommentData(data);
      setCommnetObjId(id);
    } else {
      setShowComments(true);
      setCommentData(data);
      setCommnetObjId(id);
    }
  };

  return (
    <div className="pb-2">
      <h4 className="px-2">
        Draft Sign Video
        <span className="px-2">
          <MdDescription size={26} />
        </span>
      </h4>

      <Table
        className="pb-2"
        pagination={false}
        dataSource={list}
        locale={{
          emptyText: (
            <span>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <p>
                    {localStorage.getItem("role") == "MTT"
                      ? "File is not created"
                      : "Either, File is not created or not cross checked"}
                  </p>
                }
              />
            </span>
          ),
        }}
        loading={{
          spinning: isLoading,
          indicator: (
            <span>
              <SmallSpinnerComponent />
            </span>
          ),
        }}
        columns={[
          {
            title: "File Name",
            dataIndex: "name",
            render: (value, record) => (
              <>
                <>
                  <p>
                    {location.state?.chunkName} {resultantNumber}
                  </p>
                  <p className="text-italic text-xs">
                    {new Date(Number(record.fileId)).toLocaleString()}
                  </p>
                </>
              </>
            ),
          },
          {
            title: (
              <span className={`flex items-center  justify-end mr-4-5`}>
                Action
              </span>
            ),
            dataIndex: "",
            key: "x",
            render: (item, record) => (
              <div className={`flex items-center justify-end mr-10`}>
                <VideoPlayer data={record} fileType="DRAFTFILE" />
                <>
                  <Tooltip placement="topLeft" title="Comment">
                    <Button
                      className="ml-2"
                      disabled={isPlayingStatus}
                      onClick={(e) => {
                        toggleComments(record, record.fileName);
                      }}
                    >
                      {showComments == true &&
                      commnetObjId == record.fileName ? (
                        <FaCommentSlash size={16} />
                      ) : (
                        <FaComment size={16} />
                      )}
                    </Button>
                  </Tooltip>
                </>
              </div>
            ),
          },
        ]}
      />
      <div className="pb-2">
        {showComments && <CommentsComponent chunk={commentData} />}
      </div>
    </div>
  );
};

export default CrossCheckVideo;
